import type { BrandRelationship, UserBrandInsight } from '../types';

/** Maps legacy API values during rollout. */
export function normalizeBrandRelationship(
  relationship: BrandRelationship | 'candidate',
): BrandRelationship {
  if (relationship === 'candidate') return 'detected';
  return relationship;
}

/** Per-run insight relationship (Prompt Inspector / BrandsTable). */
export function resolveInsightRelationship(brand: UserBrandInsight): BrandRelationship {
  if (brand.relationship) return normalizeBrandRelationship(brand.relationship);
  if (brand.brandType === 'own_brand') return 'you';
  if (brand.isFollowing) return 'competitor';
  if (brand.isKnown || brand.knownBrandId) return 'known';
  return 'detected';
}

export function canAddInsightAsCompetitor(brand: UserBrandInsight): boolean {
  const relationship = resolveInsightRelationship(brand);
  return relationship === 'known' || relationship === 'detected';
}
